export default __webpack_public_path__ + "static/media/image5.91081e90.svg";